// extracted by mini-css-extract-plugin
module.exports = {"w1dphg49":"w1dphg49","a1vxn2wv":"a1vxn2wv"};